import React from 'react';
import HeroSection from '../components/HeroSection';
import RatingSection from '../components/RatingSection';
import PricingSection from '../components/PricingSection';
import TrustSection from '../components/TrustSection';
import GallerySection from '../components/GallerySection';
import InstagramReelsStrip from '../components/InstagramReelsStrip';
import BookingSection from '../components/BookingSection';
import Footer from '../components/Footer';
import WhatsAppButton from '../components/WhatsAppButton';
import CallNowButton from '../components/CallNowButton';
import FirstVisitCoupon from '../components/FirstVisitCoupon';

const Home = () => {
  return (
    <div className="home-page">
      <HeroSection />
      <RatingSection />
      <PricingSection />
      <TrustSection />
      <GallerySection />
      <InstagramReelsStrip />
      <BookingSection />
      <Footer />
      <CallNowButton />
      <WhatsAppButton />
      <FirstVisitCoupon />
    </div>
  );
};

export default Home;
